<template>
  <system-information-table></system-information-table>
</template>
<script>
import SystemInformationTable from '@/../src/components/shared/SystemInformations/index.vue'
export default {
  components: {
    SystemInformationTable
  }
}
</script>
